<div class="layout-menu-profile" *ngIf="storage_service.getRolesTypeId() !== 3">
    <button class="p-link" (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled">
        <!-- <img src="assets/images/layout/settings.png" alt="avatar" style="width: 32px; height: 32px;"> -->
        <i class="pi pi-spin pi-cog" style="font-size: 2rem; display:block"></i>
        <span>
            <strong>{{translation_service.getText('lbl_quick')}}</strong>
            <small>{{translation_service.getText('lbl_setup')}}</small>
        </span>
        <i class="layout-menu-profile-toggler pi pi-fw" [ngClass]="{'pi-angle-down': menuProfilePosition === 'start' || isHorizontal, 'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal}"></i>
    </button>

    <ul *ngIf="menuProfileActive" [@menu]="isHorizontal ? 'overlay' : 'inline'">
        <li [pTooltip]="translation_service.getText(this.phase.account_task_heading)" [tooltipDisabled]="isTooltipDisabled">
            <button class="p-link" [routerLink]="['/' + this.routingOrganizerModuleType.organization + '/' + this.routingOrganizationSubModuleType.tasks]">
                <i class="pi pi-fw pi-sliders-v"></i>
                <span>{{translation_service.getText(this.phase.account_task_heading)}}</span>
            </button>
        </li>
        <li [pTooltip]="translation_service.getText(this.phase.account_cost_heading)" [tooltipDisabled]="isTooltipDisabled">
            <button class="p-link" [routerLink]="['/' + this.routingOrganizerModuleType.organization + '/' + this.routingOrganizationSubModuleType.costs]">
                <i class="pi pi-fw pi-dollar"></i>
                <span>{{translation_service.getText(this.phase.account_cost_heading)}}</span>
            </button>
        </li>
        <li pTooltip="{{translation_service.getText('lbl_staffs')}}" [tooltipDisabled]="isTooltipDisabled">
            <button class="p-link" [routerLink]="['/' + this.routingOrganizerModuleType.organization + '/' + this.routingOrganizationSubModuleType.staffs]">
                <i class="pi pi-fw pi-users"></i>
                <span>{{translation_service.getText('lbl_staffs')}}</span>
            </button>
        </li>
    </ul>
</div>
